<template>
  <!-- <v-layout column wrap > -->
  <v-dialog 
    v-model="dialogedit_profile" 
    max-width="500px" 
    persistent 
    max-height="500px"
    style="overflow-y: hidden; border-radius: 20px !important;" 
    class="Kanit"
  >
    <v-card class="Kanit">
      <v-card tile>
        <v-toolbar dark class="toolbareditdadmin">
          <v-toolbar-title>ข้อมูล Profile</v-toolbar-title>
          <!-- <v-toolbar-title v-else-if="Company.company_type === 'partner'">แก้ไขข้อมูล หน่วยงานร่วมโครงการ</v-toolbar-title>
          <v-toolbar-title v-else>แก้ไขข้อมูล หน่วยงานบำรุงรักษาเครื่อง AED</v-toolbar-title> -->
          <v-spacer></v-spacer>
          <v-btn dark icon @click="closeDialog()">
            <v-icon style="color: white !important; font-size: 20px !important;">clear</v-icon>
          </v-btn>
        </v-toolbar>
      </v-card>
      <v-card-text style="height: 215px !important; overflow-y: auto; margin-top: 20px;">
        <div>
          <v-text-field label="ชื่อ" single-line outlined hide-details v-model="first_name" class="textfieldInput" style="margin-bottom: 10px;" :disabled="edit"></v-text-field>
          <v-text-field label="นามสกุล" single-line outlined hide-details v-model="last_name" class="textfieldInput" style="margin-bottom: 10px;" :disabled="edit"></v-text-field>
        </div>
        <div v-if="edit">
          <!--  <v-btn rounded color="#a80f00" style="margin-top: 10px;text-transform: none; color: white;"  @click="comfirm()" >ยืนยัน</v-btn> -->
          <v-btn rounded color="#a80f00" style="margin-top: 10px;text-transform: none; color: white;"
            @click="edit = false">แก้ไข</v-btn>
        </div>
        <div v-else>
          <v-btn rounded color="#a80f00" style="margin-top: 10px;text-transform: none; color: white;"
            @click="cancel()">ยกเลิก</v-btn>
          <v-btn rounded color="#a80f00" style="margin-top: 10px;text-transform: none; color: white;"
            @click="comfirm()">ยืนยัน</v-btn>
        </div>
      </v-card-text>
    </v-card>
    <!-- </v-layout> -->
  </v-dialog>
</template>
<script>
export default {
  props: {
    dialogedit_profile: false,
    dataProfile: {}
  },
  data: () => ({
    BASE_URL: process.env.BASE_URL,
    first_name: '',
    last_name: '',
    email: '',
    edit: true,
    update: {}
  }),
  created () {

  },
  watch: {
    dialogedit_profile () {
      if (this.dialogedit_profile) {
        this.first_name = this.dataProfile.first_name
        this.last_name = this.dataProfile.last_name
        this.email = this.dataProfile.email
        this.update = {first_name: this.first_name, last_name: this.last_name}
      }
    }
  },
  methods: {
    cancel () {
      this.first_name = this.dataProfile.first_name
      this.last_name = this.dataProfile.last_name
      this.edit = true
    },
    clear () {
      this.edit = true
      this.update = {}
    },
    comfirm () {
      // var body = {
      //   company_id: this.Company.company_id,
      //   company_detail: this.company_detail,
      //   company_name: this.company_name
      // }
      var body = new FormData()
      body.append('profile_picture', '')
      body.append('first_name', this.first_name)
      body.append('last_name', this.last_name)
      body.append('email', this.email)
      this.$api.updateUserData(body).then((response) => {
        if (response.data.message === 'success') {
          this.$swal( 'สำเร็จ', 'แก้ไขข้อมูลโปรไฟล์สำเร็จแล้ว' , 'success' )
          // console.log(response.data.message)
          this.edit = true
          this.update = {first_name: this.first_name, last_name: this.last_name}
          this.$emit('updateProfile', this.update)
          this.$emit('closeedit_profile', false)
          this.clear()
        } else {
          // this.$swal( 'ไม่สำเร็จ', 'แก้ไขข้อมูล' + this.textType_company + 'ไม่สำเร็จแล้ว', 'error' )
          // this.closeDialog(false)
        }
      })

    },
    closeDialog () {
      if (this.first_name !== this.dataProfile.first_name || this.last_name !== this.dataProfile.last_name) {
        if (!this.edit) {
          this.$swal({
            text: 'ต้องการยืนยันการเปลี่ยนแปลงก่อนปิดหรือไม่?',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#2562af',
            cancelButtonColor: '#9f9f9f',
            confirmButtonText: 'ยืนยัน',
            cancelButtonText: 'ปิด',
            confirmButtonClass: 'btn btn-danger',
            cancelButtonClass: 'btn btn-success',
            buttonsStyling: true,
            showCloseButton: true,
            reverseButtons: true
          }).then((result) => {
            if (result.value) {
              this.comfirm()
            }
          })
        } else {
          this.$emit('updateProfile', this.update)
          this.$emit('closeedit_profile', false)
          this.clear()
        }
      } else {
        this.$emit('closeedit_profile', false)
        this.clear()
      }
      // this.$emit('closeedit_profile', false, update)
    },
    editCompany () {
      var body = {
        company_id: this.Company.company_id,
        company_detail: this.company_detail,
        company_name: this.company_name
      }
      this.$api.editCompany(body).then((response) => {
        if (response.data.message === 'success') {
          this.$swal( 'สำเร็จ', 'แก้ไขข้อมูล' + this.textType_company + 'สำเร็จแล้ว' , 'success' )
          this.closeDialog(true)
        } else {
          this.$swal( 'ไม่สำเร็จ', 'แก้ไขข้อมูล' + this.textType_company + 'ไม่สำเร็จแล้ว', 'error' )
          this.closeDialog(false)
        }
      })
    },
    getComapny () {
      this.$api.getAllCompany().then((response) => {
        if (response.data.message === 'success') {
          this.listHeade_company = _.reject(response.data.data, ['company_type', 'maintenance'])
        }
      })
    },
    btncancle () {
      this.username = ''
      this.password = ''
      this.company_name = ''
      this.company_address = ''
      this.company_email = ''
      this.company_tell = ''
      this.checkbox1 = false
      this.checkbox2 = false
    }
  }
}
</script>
<style media="screen" scoped>
.Kanit{
  font-family: 'Kanit', sans-serif !important;
}
>>>.v-textarea.v-text-field--enclosed.v-text-field--single-line .v-label {
  top: 10px !important;
}
>>>.v-list-item .v-list-item__title {
    font-family: 'Kanit', sans-serif !important;

}
.inputinfor_address {
  height: 110px !important;
  border-width: thin !important;
  border-style: solid !important;
  border-color: #a80e00 !important;
  border-radius: 7px !important;
  background-color: white !important;
}
.inputinfor {
  height: 50px !important;
  border-width: thin !important;
  border-style: solid !important;
  border-color: #a80e00 !important;
  border-radius: 7px !important;
  background-color: white !important;
}
.inputinfor_dis {
  height: 50px !important;
  border-width: thin !important;
  border-style: solid !important;
  border-color: #a80e00 !important;
  border-radius: 7px !important;
  background-color: #FAF0F0 !important;
}
>>>.layout.wrap {
  flex-wrap: wrap;
}
>>>.v-input--selection-controls {
  margin-top: 0px;
  padding-top: 0px;
}
.toolbareditdadmin {
  border-top-color: transparent !important;
  border-left-color: transparent !important;
  border-width: thin !important;
  border-right-color: transparent !important;
  border-style: solid !important;
  height: 64px !important;
  border-left-style: initial !important;
  border-right-style: initial !important;
  border-radius: 0px !important;
  border-bottom-color: #a80e00 !important;
  background-color: #a80e00 !important;
  color: white !important;
  border-width: thin !important;
  box-shadow: none !important;
}
/* >>>.v-input__slot {
  border-radius: 10px !important;
  border-style: solid !important;
  border-width: thin !important;
  border-color: #a80f00 !important;
  background-color: #a80d0021 !important;
} */
.btngen {
  background-color: white !important;
  color: #a80f00 !important;
  border-color: #a80f00 !important;
  border-style: solid !important;
  border-width: thin !important;
  text-transform: none !important;
  width: 120px !important;
}
.btnedituser {
  background-color: #a80f00 !important;
  color: #fafafa !important;
  border-color: #a80f00 !important;
  border-style: solid !important;
  border-width: thin !important;
  text-transform: none !important;
}
.btnedituser:disabled {
  background-color: #a80f0099 !important;
  color: #fafafa9c !important;
  border-color: #a80f0091 !important;
  border-style: solid !important;
  border-width: thin !important;
}

.btncancle {
  background-color: #fafafa !important;
  color: #a80f00 !important;
  border-color: #a80f00 !important;
  border-style: solid !important;
  border-width: thin !important;
  width: 160px !important;
}
>>>.theme--light.v-btn.v-btn--disabled:not(.v-btn--icon):not(.v-btn--flat):not(.v-btn--outline) {
  background-color: #a80f0099 !important;
  color: #fafafa9c !important;
  border-color: #a80f0091 !important;
  border-style: solid !important;
  border-width: thin !important;
}


>>>.v-input .v-label {
    height: 30px;
    line-height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/edit/edit_profile_modal.vue